// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Jz-z","modalContent":"Kz-z","header":"Lz-z","close":"Mz-z"};